module.exports = __webpack_public_path__ + "img/7.0e7f89b4.svg";